import { createContext } from "react";

const DeadlineContext = createContext({
    deadlines: {},
    setDeadlines: () => { },
});

export default DeadlineContext;
